import {useSessionStorage} from '@aboutyou/storage';

export const OSP_REDIRECT_KEY = 'ay-redirect-to-app';

export const useGetOSPRedirectValue = () => {
  const [device] = useSessionStorage<string>({
    key: OSP_REDIRECT_KEY,
    defaultValue: '',
  });

  return device;
};
